/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityInfraIssuesDashboardFilters {
    getFixupPrototypeFunction() { return SecurityInfraIssuesDashboardFilters.fixupPrototype; }

    static newInstance(model: Partial<SecurityInfraIssuesDashboardFilters>): SecurityInfraIssuesDashboardFilters {
        let obj = Object.assign(new SecurityInfraIssuesDashboardFilters(), model);
        SecurityInfraIssuesDashboardFilters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityInfraIssuesDashboardFilters>): SecurityInfraIssuesDashboardFilters {
        if (!model) return null;
        return SecurityInfraIssuesDashboardFilters.newInstance(<SecurityInfraIssuesDashboardFilters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityInfraIssuesDashboardFilters) {
        if (!obj) return;

        models.SecurityInfraIssuesDashboardFilters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityInfraIssuesDashboardFilters): boolean {
        Object.setPrototypeOf(obj, SecurityInfraIssuesDashboardFilters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.query) {
            models.QueryOperator.fixupPrototype(this.query);
        }
    }

    /**
     * Tenant ID to filter the issues. This can be fetched from the List Tenants API call.
     */
    tenant_id: string;

    /**
     * Query based on Cloud Providers, Cloud Account Ids, Severities, ResourceCategories, ResourceTypes, Resources
     */
    query: models.QueryOperator;

}
